import { useCallback } from 'react';

import type { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-enterprise';

import { get, isEmpty, isNotDefined } from '@enterprise/core';

type MenuItems = (MenuItemDef | string)[];

export const useGetContextMenuItems = <TData = unknown>() => {
  return useCallback((params: GetContextMenuItemsParams<TData>) => {
    // This is a very simple example, but you could do anything here, including
    // providing custom actions based on the data in the row, or the column, or
    // anything else you can think of. -JP

    const menuItems: MenuItems = [
      {
        // action: () => {
        // },
        name: `Copy something from ${params.column?.getColId()}`,
      },
      {
        name: 'Copy something else',
        // action: () => {
        //     console.log('copying something else', params);
        //     console.log('node data', params.node?.data);
        // }
      },
      'separator',
      'copy',
      'copyWithHeaders',
      'paste',
      'separator',
      'export',
      'separator',
      'chartRange',
      'separator',
    ];

    // Get the rest of the available context
    const colDef = params.column?.getColDef() ?? {};

    // console.log('DefaultContextMenu.ts -> getContextMenuItems ::: colDef: ', colDef);

    if (isNotDefined(colDef.context)) {
      return menuItems;
    }

    // console.log('DefaultContextMenu.ts -> getContextMenuItems ::: context: ', colDef.context);
    // Check for the presence of menuItemLinks in the column context
    const menuItemLinks: unknown[] = [];

    if ('menuItemLinks' in colDef.context) {
      menuItemLinks.push(...get<unknown[]>(colDef.context, 'menuItemLinks', []));
    }

    if (isEmpty(menuItemLinks)) {
      return menuItems;
    }

    menuItems.push('separator');

    // for (const item of menuItemLinks) {
    //   const newItem: CustomMenuItemLink = {
    //     linkTemplate: '',
    //     nameTemplate: '',
    //   };
    //   // // console.log('DefaultContextMenu.ts -> getContextMenuItems ::: item: ', item);
    //   // // Check for the presence of a nameTemplate and linkTemplate
    //   // if (item.nameTemplate !== undefined && item.nameTemplate !== '') {
    //   //   newItem.nameTemplate = item.nameTemplate;
    //   // }
    //   // if (item.linkTemplate !== undefined && item.linkTemplate !== '') {
    //   //   newItem.linkTemplate = item.linkTemplate;
    //   // }
    //   // // console.log('DefaultContextMenu.ts -> getContextMenuItems ::: params: ', params);
    //   // Object.keys(params.node?.data).forEach((key) => {
    //   //   const val = params.node?.data[key]
    //   //   // console.log('DefaultContextMenu.ts -> getContextMenuItems ::: key: ', key, 'value: ', val);
    //   //   newItem.nameTemplate = newItem.nameTemplate.replace(`{${key}}`, val);
    //   //   newItem.linkTemplate = newItem.linkTemplate.replace(`{${key}}`, val);
    //   // });
    //   // if (newItem.nameTemplate === '') {
    //   //   newItem.nameTemplate = 'View Details'
    //   //   // console.log('using default menu item name', newItem.nameTemplate);
    //   // }
    //   // // console.log('DefaultContextMenu.ts -> getContextMenuItems ::: item.linkTemplate: ',newItem.linkTemplate);
    //   // // menuItems.push({
    //   // //     name: newItem.nameTemplate,
    //   // //     icon: '<span class="ag-icon ag-icon-linked" unselectable="on" role="presentation"></span>',
    //   // //     action: () => {
    //   // //         console.log('Navigate away to ', newItem.linkTemplate);
    //   // //         navigate(newItem.linkTemplate);
    //   // //     }
    //   // // })
    // }

    return menuItems;
  }, []);
};
